import { GameDto } from '../dtos/game.dto'
import { GameProps } from '../models/game.props'
import { gamePlayerMapper } from './game-player.mapper'
import { cardsMapper } from './cards.mapper'
import { Contract } from '../models/contract'

export const gamePropsMapper = {
  mapToGameProps(gameDto: GameDto): GameProps {
    return {
      ...gameDto,
      user: gamePlayerMapper.mapToGamePlayer(gameDto.user),
      rightOpponent: gamePlayerMapper.mapToGamePlayer(gameDto.rightOpponent),
      leftOpponent: gamePlayerMapper.mapToGamePlayer(gameDto.leftOpponent),
      talonCards: cardsMapper.mapToCards(gameDto.talonCards),
      discardedCards: cardsMapper.mapToCards(gameDto.discardedCards),
      contract: new Contract(gameDto.contract),
      highlightedCards: cardsMapper.mapToCards(gameDto.highlightedCards),
    }
  },
}
